import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "*",
      redirect: "/main",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },
    {
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    },
    {
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },
    {
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () => import("@/views/home/home.vue"),
        }, {
          path: "gps",
          name: RouterNames.Gps,
          component: () => import("@/views/gps/GpsCentros.vue"),
        }, {
          path: "ruta-gps",
          name: RouterNames.RutaGps,
          component: () => import("@/views/gps/RutacentrosGps.vue"),
        }, {
          path: "planificador-rutas",
          name: RouterNames.PlanificadorRutas,
          component: () => import("@/views/gps/RoutePlanner.vue"),
        }, {
          path: "planificador-rutas-backend",
          name: RouterNames.PlanificadorRutasBackend,
          component: () => import("@/views/gps/RoutePlannerBackend.vue"),
        }, {
          path: "planificador-rutas-manual",
          name: RouterNames.PlanificadorRutasManual,
          component: () => import("@/views/gps/RoutePlannerManual.vue"),
        },
        {
          path: "planificaciones",
          name: RouterNames.planificaciones,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "edit-ruta/:id",
              name: RouterNames.EditRuta,
              component: () => import("@/views/gps/RoutePlannerManual.vue"),
            },
          ],
        },

        {
          path: "tablas",
          name: RouterNames.tablas_test,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tabla/:id",
              name: RouterNames.table,
              component: () =>
                import("@/views/dynamic_tables/full_dynamic_table.vue"),
            },
            {
              path: "dxtabla/:id",
              name: RouterNames.dxtable,
              component: () =>
                import("@/components/DataTableGenerico/DxFullDataTable.vue"),
            },
          ],
        }, {
          path: "formularios",
          name: RouterNames.formularios_dynamicos,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "formulario/:id/:id_objeto",
              name: RouterNames.formulario_dynamico,
              component: () =>
                import("@/views/createdynamicform/showdynamicform.vue"),
            },
          ],
        },
        {
          path: "tbkn",
          name: RouterNames.tbkn,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "tbkn/:id",
              name: RouterNames.viewtbkn,
              component: () =>
                import("@/views/dynamic_views/dynamic_change_views.vue"),
            },
          ],
        },
        {
          path: "kanban",
          name: RouterNames.kanban,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "kanban/:id",
              name: RouterNames.viewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
            {
              path: "fullkanban/:id",
              name: RouterNames.FullViewKanban,
              component: () => import("@/views/dynamickanban/ViewKanban.vue"),
            },
          ],
        },
        {
          path: "enumeraciones",
          name: RouterNames.enumeraciones,
          component: () =>
            import("@/components/titulopantalla/titulo-reactivo.vue"),
          children: [
            {
              path: "enumeracion/:id_cabezera",
              name: RouterNames.enumeracion,
              component: () =>
                import("@/views/prioridades/GenericPrioridadesForm.vue"),
            },
          ],
        },
        {
          path: "administracion",
          name: RouterNames.administracion,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "usuarios",
              name: RouterNames.usuarios,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.usuarioslista,
                  component: () => import("@/views/usuarios/UsuariosLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.usuariosformulario,
                  component: () =>
                    import("@/views/usuarios/UsuariosFormulario.vue"),
                  children: [],
                },
              ],
            }, {
              path: "centros",
              name: RouterNames.centros,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.centros_gruposformulario,
                  component: () =>
                    import("@/views/grupos/GruposCentrosFormulario.vue"),
                  children: [],
                },
              ],
            }, {
              path: "importacion-kml",
              name: RouterNames.importacion,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario",
                  name: RouterNames.importacionformulario,
                  component: () =>
                    import("@/views/home/KmlImportFile.vue"),
                  children: [],
                },
              ],
            }, {
              path: "importacion-progreso",
              name: RouterNames.importacionprogreso,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario",
                  name: RouterNames.importacionprogresoformulario,
                  component: () =>
                    import("@/views/importacion/ProgresImport.vue"),
                  children: [],
                },
              ],
            }, {
              path: "centros",
              name: RouterNames.centros,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.centrosformulario,
                  component: () =>
                    import("@/views/centros/CentrosFormulario.vue"),
                  children: [],
                },
              ],
            }, {
              path: "importacion-excel",
              name: RouterNames.importacion_excel,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario",
                  name: RouterNames.importacionformulario_excel,
                  component: () =>
                    import("@/views/home/ExcelImport.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "grupos",
              name: RouterNames.grupos,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.gruposlista,
                  component: () => import("@/views/grupos/GruposLista.vue"),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.gruposformulario,
                  component: () =>
                    import("@/views/grupos/GruposFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "rol",
              name: RouterNames.rol,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.rollista,
                  component: () => import("@/views/roles/RolesLista.vue"),
                  children: [],
                },
                {
                  path: "formulario",
                  name: RouterNames.rolformulario,
                  component: () => import("@/views/roles/RolesFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "notificaciones/formulario",
              name: RouterNames.notificaciones,
              component: () =>
                import("@/views/notificaciones/NotificacionesForm.vue"),
            }, {
              path: "configuracion/formulario/:id",
              name: RouterNames.configuracion_clientes,
              component: () =>
                import("@/views/configuracion/formulario.vue"),
            },
          ],
        },
        {
          path: "plataforma",
          name: RouterNames.plataforma,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "instalacion/formulario",
              name: RouterNames.instalacion_plataforma,
              component: () => import("@/views/instalacion/instalacion.vue"),
            },
            {
              path: "menu",
              name: RouterNames.menu_plataforma,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.menu_plataforma_lista,
                  component: () =>
                    import("@/views/plataforma/menu/MenuLista.vue"),
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.menu_plataforma_formulario,
                  component: () =>
                    import("@/views/plataforma/menu/MenuFormulario.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "createdynamic",
              name: RouterNames.createdynamicmenu,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.createdynamicfromulario,
                  component: () =>
                    import("@/views/createdynamicform/createdynamicform.vue"),
                  children: [],
                },
              ],
            },
            {
              path: "tablas",
              name: RouterNames.tablas,
              component: () =>
                import("@/components/titulopantalla/titulo-reactivo.vue"),
              children: [
                {
                  path: "lista",
                  name: RouterNames.tablaslista,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_lista.vue"
                    ),
                  children: [],
                },
                {
                  path: "formulario/:id",
                  name: RouterNames.tablasformulario,
                  component: () =>
                    import(
                      "@/views/dynamic_tables/views_settings/dynamic_tables_formulario.vue"
                    ),
                  children: [],
                },
              ],
            },
            {
              path: "clientes",
              name: RouterNames.clientes,
              component: () => import("@/components/titulopantalla/titulo.vue"),
              children: [
                {
                  path: "formulario/:id",
                  name: RouterNames.clientesformulario,
                  component: () =>
                    import(
                      "@/views/plataforma/clientes/ClientesFormulario.vue"
                    ),
                  children: [],
                },
              ],
            },
          ],
        },
        {
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
